// src/components/ReCaptchaCheckbox.tsx
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

interface Props {
  onChange: (token: string | null) => void;
}

const ReCaptchaCheckbox: React.FC<Props> = ({ onChange }) => {
  return (
    <ReCAPTCHA
      sitekey={'6Lfpio4rAAAAAD2uAtspVt83bplK1JYRshNc6vBA'}
      onChange={onChange}
      // index.html mirrors the OS theme onto <html data-theme>; the widget
      // only reads its theme at mount, which is when it matters.
      theme={document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light'}
    />
  );
};

export default ReCaptchaCheckbox;
